import React from 'react';

import i18n from 'i18';

// @mui
import { Box, MenuItem, TextField, Typography } from '@mui/material';

export default class DialogBooleanField extends React.Component {
    onChange = (event, id) => {
        const trueLabel = this.props.field.trueLabel || 'enabled';
        const isTrue = event.target.value === trueLabel;
        this.props.onChange(id, isTrue);
    };

    render() {
        // field, value, onChange
        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const placeholderLabel = i18n.t(
            `placeholder.${this.props.field.label}`
        );
        const trueLabel = this.props.field.trueLabel || 'enabled';
        const falseLabel = this.props.field.falseLabel || 'disabled';
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        return (
            <Box mb={2}>
                <Typography variant="subtitle2">{translatedLabel + requiredLabel}</Typography>
                <TextField
                    select
                    margin="dense"
                    value={this.props.value ? trueLabel : falseLabel}
                    sx={{
                        '& .MuiSelect-select .notranslate::after':
                            placeholderLabel
                                ? {
                                    content: `"${placeholderLabel}"`,
                                    opacity: 0.7
                                }
                                : {}
                    }}
                    fullWidth
                    onChange={(event) =>
                        this.onChange(event, this.props.field.id)
                    }
                >
                    {[trueLabel, falseLabel].map((item) => (
                        <MenuItem key={item} value={item}>
                            {i18n.t(`enums.${item}`)}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
        );
    }
}
